<div class="boxWhite md">

  <h4>CREAR SERVICIO COMERCIAL</h4>

  <button class="btn btnClose" (click)="cerrarModal()">
    <img src="assets/img/icoClose.svg">
  </button>

  <div class="contModal">
    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <select class="form-select" [(ngModel)]="selectedTripType" (change)="onTripTypeChange(selectedTripType)">
            <option [value]="tripTypes.COMERCIAL">SERVICIO COMERCIAL</option>
            <option [value]="tripTypes.NO_COMERCIAL">SERVICIO NO COMERCIAL</option>
            <option [value]="tripTypes.ESPECIAL">SERVICIO ESPECIAL</option>
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <ng-select placeholder="BUSCAR SERVICIO..." [multiple]="false" [items]="listaServiciosV3"
            bindLabel="idServicio" [(ngModel)]="servicioV3Seleccionado">
            <ng-template ng-label-tmp let-item="item">
              <span>{{ item.idServicio }}, {{item.sentido}}, {{item.paraderoOrigen}}, {{item.paraderoSentido}}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span>{{ item.idServicio }}, {{item.sentido}}, {{item.paraderoOrigen}}, {{item.paraderoSentido}}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="mb-4">
          <select class="form-select" disabled>
            <option *ngIf="!servicioV3Seleccionado" value="">Sentido</option>
            <option *ngIf="servicioV3Seleccionado" value="">{{servicioV3Seleccionado.sentido}}</option>
          </select>
        </div>
      </div>
    </div>

    <hr>

    <!-- ORIGEN -->
    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>TERMINAL ORIGEN</h6>
          <ng-select placeholder="TERMINAL ORIGEN" [multiple]="false" [items]="listaSucursales" bindLabel="nombre"
            [(ngModel)]="terminalOrigenV3Seleccionado">
            <ng-template ng-label-tmp let-item="item">
              <span>{{ item.nombre }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span>{{ item.nombre }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>FECHA SALIDA TERMINAL</h6>
          <input type="date" class="form-control" [(ngModel)]="fechas['fechaSalidaTerminalV3']">
        </div>
      </div>

      <div class="col-sm">
        <h6>HORA SALIDA TERMINAL</h6>
        <div class="hora mb-4">
          <div class="grInput">

            <button class="btn" (click)="decrementTime('horaSalidaTerminalV3')">
              <img src="assets/img/icoMenos.svg">
            </button>

            <input type="text" class="form-control" [(ngModel)]="horas['horaSalidaTerminalV3']"
              (input)="formatearTiempo($event, 'horaSalidaTerminalV3')"
              (blur)="normalizarCampoHora('horaSalidaTerminalV3')">

            <button class="btn" (click)="incrementTime('horaSalidaTerminalV3')">
              <img src="assets/img/icoMas.svg">
            </button>

          </div>
        </div>
      </div>

      <div class="col-sm-auto">
        <h6>HABILITAR</h6>
        <div class="form-check form-switch mt-2 mb-4">
          <input class="form-check-input" type="checkbox" role="switch">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>FECHA INICIO VIAJE</h6>
          <input type="date" class="form-control" [(ngModel)]="fechas['fechaInicioViajeV3']">
        </div>
      </div>

      <div class="col-sm">
        <h6>HORA INICIO VIAJE</h6>
        <div class="hora mb-4">
          <div class="grInput">

            <button class="btn" (click)="decrementTime('horaInicioViajeV3')">
              <img src="assets/img/icoMenos.svg">
            </button>

            <input type="text" class="form-control" [(ngModel)]="horas['horaInicioViajeV3']"
              (input)="formatearTiempo($event, 'horaInicioViajeV3')" (blur)="normalizarCampoHora('horaInicioViajeV3')">

            <button class="btn" (click)="incrementTime('horaInicioViajeV3')">
              <img src="assets/img/icoMas.svg">
            </button>

          </div>
        </div>
      </div>
    </div>

    <hr>

    <!-- ORIGEN -->
    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>TERMINAL DESTINO</h6>
          <ng-select placeholder="TERMINAL DESTINO" [multiple]="false" [items]="listaSucursales" bindLabel="nombre"
            [(ngModel)]="terminalDestinoV3Seleccionado">
            <ng-template ng-label-tmp let-item="item">
              <span>{{ item.nombre }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span>{{ item.nombre }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>FECHA TÉRMINO VIAJE</h6>
          <input type="date" class="form-control" [(ngModel)]="fechas['fechaTerminoViajeV3']">
        </div>
      </div>

      <div class="col-sm">
        <h6>HORA TERMINO VIAJE</h6>
        <div class="hora mb-4">
          <div class="grInput">

            <button class="btn" (click)="decrementTime('horaTerminoViajeV3')">
              <img src="assets/img/icoMenos.svg">
            </button>

            <input type="text" class="form-control" [(ngModel)]="horas['horaTerminoViajeV3']"
              (input)="formatearTiempo($event, 'horaTerminoViajeV3')"
              (blur)="normalizarCampoHora('horaTerminoViajeV3')">

            <button class="btn" (click)="incrementTime('horaTerminoViajeV3')">
              <img src="assets/img/icoMas.svg">
            </button>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>FECHA LLEGADA TERMINAL</h6>
          <input type="date" class="form-control" [(ngModel)]="fechas['fechaLlegadaTerminalV3']">
        </div>
      </div>

      <div class="col-sm">
        <h6>HORA LLEGADA TERMINAL</h6>
        <div class="hora mb-4">
          <div class="grInput">

            <button class="btn" (click)="decrementTime('horaLlegadaTerminalV3')">
              <img src="assets/img/icoMenos.svg">
            </button>

            <input type="text" class="form-control" [(ngModel)]="horas['horaLlegadaTerminalV3']"
              (input)="formatearTiempo($event, 'horaLlegadaTerminalV3')"
              (blur)="normalizarCampoHora('horaLlegadaTerminalV3')">

            <button class="btn" (click)="incrementTime('horaLlegadaTerminalV3')">
              <img src="assets/img/icoMas.svg">
            </button>

          </div>
        </div>
      </div>

      <div class="col-sm-auto">
        <h6>HABILITAR</h6>
        <div class="form-check form-switch mt-2 mb-4">
          <input class="form-check-input" type="checkbox" role="switch">
        </div>
      </div>
    </div>



    <div class="pb-4">
      <button class="btn btnOrange d-block mx-auto" (click)="crearViajeComercialV3()">CREAR SERVICIO COMERCIAL</button>
    </div>

  </div>
</div>